import { MenuOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useIsMobile } from '@/context/IsMobileContext.tsx';
import { NotificationMenu } from '@/components/NotificationMenu/NotificationMenu.tsx';
import { AppLogo } from '@/icons/AppLogo.tsx';
import { TopNav } from '@/components/Layouts/TopNav.tsx';
import { UserMenu } from '@/components/Layouts/UserMenu.tsx';
import type { TNavItem } from '@/components/Layouts/navigation.tsx';
import type { TUser } from '@/services/auth/auth.types.ts';

interface IHeader {
  items: TNavItem[];
  user?: TUser;
  onOpenMobileMenu: () => void;
}

const homeFor = (role?: string) =>
  role === 'CLIENT' ? '/client' : role === 'ADVISOR' ? '/advisor/clients' : '/';

export const MainHeader = ({ items, user, onOpenMobileMenu }: IHeader) => {
  const { isMobile } = useIsMobile();
  const subAccount = user?.sub_account;

  return (
    <header className='app-header'>
      <div className='app-header__inner'>
        <Link to={homeFor(user?.role)} className='app-header__brand' aria-label='Home'>
          <AppLogo cropped width={isMobile ? 52 : 62} height={isMobile ? 38 : 45} />
        </Link>

        {!isMobile && <TopNav items={items} />}

        <div className='app-header__actions'>
          {subAccount && !isMobile && (
            <span
              className='app-header__sub-account'
              title={`Sub-account mode: ${subAccount.behaviour}`}
            >
              Viewing as <strong>{subAccount.name}</strong>
            </span>
          )}

          <NotificationMenu />

          {isMobile ? (
            <button
              type='button'
              className='app-header__icon-btn'
              onClick={onOpenMobileMenu}
              aria-label='Open menu'
            >
              <MenuOutlined />
            </button>
          ) : (
            <UserMenu user={user} />
          )}
        </div>
      </div>
    </header>
  );
};
